<template>
  <v-row justify="center">
    <PModalBox
      :open-dialog="openDialog"
      header="Import suppliers"
      size="large"
      @close-dialog="close"
    >
      <template #content>
        <UploadSuppliers @suppliers-uploaded="emit('suppliers-uploaded')" />
        <TemplateDownload />
      </template>
    </PModalBox>
  </v-row>
</template>

<script setup lang="ts">
import UploadSuppliers from "@/views/supplier-registry/UploadSuppliers.vue";
import TemplateDownload from "@/views/supplier-registry/TemplateDownload.vue";
import PModalBox from "@/components/custom/PModalBox.vue";

const emit = defineEmits<{
  (e: "close-dialog"): void;
  (e: "suppliers-uploaded"): void;
}>();

const props = defineProps<{
  openDialog: boolean;
}>();

const close = () => {
  emit("close-dialog");
};
</script>
